/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  const onlineButton = document.getElementById('online-cart-discount-btn');
  if (!onlineButton) return;

  let applyingDiscount = false;

  onlineButton.addEventListener('click', function () {
    sessionStorage.setItem('apply_online_discount', '1');
  });

  document.documentElement.addEventListener('product:added', async function () {
    if (sessionStorage.getItem('apply_online_discount') !== '1') return;
    if (applyingDiscount) return;

    applyingDiscount = true;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          discount: 'SCONTO10'
        })
      });

      sessionStorage.removeItem('apply_online_discount');

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 300);

    } catch (error) {
      console.error('Erro ao aplicar desconto SCONTO10:', error);
    } finally {
      applyingDiscount = false;
    }
  });
});


// GlucoMax PL: translate the BK Reviews star-count label into natural Polish.
(function () {
  function polishReviewWord(count) {
    if (count === 1) return 'opinia';

    var mod10 = count % 10;
    var mod100 = count % 100;

    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
      return 'opinie';
    }

    return 'opinii';
  }

  function getReviewCount(scope) {
    var text = (scope && scope.textContent) || '';
    var match =
      text.match(/\((\d+)\s*(?:Reviews?|opinia|opinie|opinii)?\)/i) ||
      text.match(/(\d+)\s*Reviews?/i);

    return match ? parseInt(match[1], 10) : null;
  }

  function fixBkScope(scope) {
    if (!scope) return;

    var count = getReviewCount(scope);
    var replacement = count === null ? 'opinii' : polishReviewWord(count);
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(function (node) {
      if (!node.nodeValue || !/\bReviews?\b/i.test(node.nodeValue)) return;
      node.nodeValue = node.nodeValue.replace(/\bReviews?\b/gi, replacement);
    });
  }

  function fixBkReviews(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches && root.matches('#bk-star-section, .bk-reviews')) {
      fixBkScope(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('#bk-star-section, .bk-reviews').forEach(fixBkScope);
    }
  }

  function initBkPolishTranslation() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang && lang.indexOf('pl') !== 0) return;

    fixBkReviews(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          var parent = mutation.target.parentElement;
          var scope = parent && parent.closest ? parent.closest('#bk-star-section, .bk-reviews') : null;
          if (scope) fixBkScope(scope);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          var scope = node.matches && node.matches('#bk-star-section, .bk-reviews')
            ? node
            : (node.closest ? node.closest('#bk-star-section, .bk-reviews') : null);

          if (scope) fixBkScope(scope);
          fixBkReviews(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    var attempts = 0;
    var timer = setInterval(function () {
      fixBkReviews(document);
      attempts += 1;
      if (attempts >= 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBkPolishTranslation);
  } else {
    initBkPolishTranslation();
  }
})();
